import {SAVER_NAMESPACE,SAVER_COMMITS} from '@/store/contracts'
//模块必须实现getter:hasChangedData ,actions:SAVE
function createModuleSaverSyncPlugin(namespace){
    const plugin = (store) => {
        const saveAction = {
            key:namespace,
            execute: ()=>{
                return store.dispatch(namespace+'/SAVE')
            }
        }
        // 当 store 初始化后调用
        store.watch(
            (state, getters) => {
                return getters[namespace+'/hasChangedData']
            },
            (hasChangedData) => {
                if(hasChangedData){
                    store.commit(SAVER_NAMESPACE+'/'+SAVER_COMMITS.REQUIRE_SAVE, saveAction)
                }else{
                    store.commit(SAVER_NAMESPACE+'/'+SAVER_COMMITS.CANCEL_SAVE, saveAction.key)
                }
            },
            {immediate:true}
            )
    }

    return plugin
}


export {createModuleSaverSyncPlugin};
